<template>
                <div class="agreement-letter">
                    <div class="agreement-letter__body">                        
                        <h3 v-if="letterData.price_method > 0">Pris</h3>
                        <p v-if="letterData.price_method == 1" class="intro">Vores honorar for denne opgave udgør en fast aftalt pris på <span v-price="letterData.price"></span> <b>inkl. moms.</b> <span v-if="letterData.discountPercent > 0">Rabat {{ letterData.discountPercent }}%.</span> Moms udgør heraf <span v-price="vat"></span> <template v-if="letterData.other_case">Afregning sker på anden sag.</template> <template v-if="letterData.against_capital">Vores honorar og gebyr til Erhvervsstyrelsen modregnes i den indbetalte selskabskapital.</template></p>
                        <p v-if="letterData.price_method == 2">
                            Vores honorar for denne opgave afregnes som aftalt efter medgået tid. Prisen udgør kr. 1.250,00 - 3.750,00 <b>inkl. moms</b> i timen. Enhver opgave vil blive tilrettelagt således, at vi inddrager personale med lavere timetakster, til at bistå med arbejde, hvor det skønnes hensigtsmæssigt. Det er altid muligt, at få oplyst sagens løbende omkostninger.
                        </p>

                        <p v-if="letterData.tax > 0">Afgifter/gebyrer udgør <span v-price="letterData.tax"></span>, momsfrit.</p>

                        <h3>Deponering</h3>
                        <template v-if="letterData.deposit_method === 1">
                            <p>Til sikkerhed for vores honorar og kendte omkostninger bedes <span v-price="letterData.deposit_price"></span> indsættes på vores klientkonto i Nykredit med reg.nr. 8117 og konto nr. 3822677. Navngiv venligst overførslen {{ letterData.caseid }}.</p>
                            <p>Din indbetaling registreres indenfor 1-2 bankdage. Vores kvittering herfor vil fremgå i dit NEMBLIK på sagen, og du vil modtage en kvittering til din e-mail.</p>
                            <p>Vi vil høfligt påminde om beløbet indtil deponering er modtaget. Krydser vores påmindelser din indbetaling, skal du naturligvis set bort fra disse.</p>
                        </template>
                        <p v-if="letterData.deposit_method === 0">Efter aftale skal der ikke foretages deponering forud for sagens opstart.</p>
                        <p>Se sagens fulde aftalebrev/ordrebekræftigelse <a href="javascript:void(0)" @click="$emit('showletter')">her</a></p>
                    </div>
                </div>
</template>

<script>
export default {
  props: {
      letterData: {type: Object, default() {return {
          caseid: '',
          fullname: '',
          address: '',
          postal: '',
          city: '',
          date: '',
          producttxt: '',
          addons: [ ],
          contract_lines: [ ],
          responsible: '',
          assistant: '',
          price: 0,
          discount: 0,
          discountPercent: 0,
          price_method: 0,
          deposit_method: 0,
          deposit_price: 0,
          tinglysning: '',
          tax: 0,
          insurance: false,
          notice: '',
          tingopkrav: '',
          debitor_shift: false,
          residence_requirement: false,
          other_case: false,
          nemreg_price_data: {
            type: 'beregning',
            exchange_rate: 0,
            capital: 0,
            deposit: 0
          },
          against_capital: false
      }}}
  },
  computed: {
      vat() {
          return this.letterData.price * 0.20;
      }
  }
}
</script>
